import { ALL_JP_BADGES, SPJ_JACKPOT_GAMES } from '@repo/common';
import { getBadgeSectionName, getJackpotSlug, getNoJackpotException, SECTION_BADGE_REGISTRY } from 'features/games';
import type IGameSettings from '../../../types/models/IGameSettings';

export interface JackpotBadge {
  slug: string;
  label: string;
  isSPJ: boolean;
  fileName: string;
  sectionName: string;
  showPlate: boolean;
}

// Mirrors the normal game card: `game` must already be the effectiveData from
// useEffectiveGameData, and `sectionName` the effectiveSectionName, so Premium
// Link resolution happens once in the hook instead of being repeated here. Only
// the plate is gated on ALL_JP_BADGES — an unknown badge renders nothing via
// Image's onError, same as Game.tsx.
export const deriveJackpotBadge = (game: IGameSettings, sectionName: string): JackpotBadge | null => {
  const featureLabel = getNoJackpotException(game.gameFeatures);
  const label = game.displayJackpotName || game.jackpotName || featureLabel;
  if (!label) return null;

  const plateSlug = getJackpotSlug(featureLabel ?? game.jackpotName ?? label);
  const badgeSectionName = getBadgeSectionName(game, sectionName);

  return {
    slug: getJackpotSlug(label),
    label,
    isSPJ: SPJ_JACKPOT_GAMES.includes(game.displayJackpotName || game.jackpotName || ''),
    fileName: SECTION_BADGE_REGISTRY[badgeSectionName]?.fileName ?? getJackpotSlug(label),
    sectionName: badgeSectionName,
    showPlate: ALL_JP_BADGES.includes(plateSlug),
  };
};
